import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';
import { AppState } from 'services/types';

// Selectors
import TimesheetHolidayGate from 'components/TimesheetHolidayGate';
import TimesheetHolidayIcon from 'components/TimesheetHolidayIcon';
import { EntityId } from 'services/entities/types';
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface ConnectedProps {
    date?: string;
    entityId: EntityId;
}

type Props = ConnectedProps;

export class TimesheetEntryDateComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | string | null {
        const { date, entityId } = this.props;
        if (!date) return null;

        return (
            <TimesheetHolidayGate
                fallback={moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                timesheetDate={date}
                timesheetEntityId={entityId}
            >
                <div style={{ display: 'flex' }}>
                    {moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                    <TimesheetHolidayIcon
                        timesheetDate={date}
                        timesheetEntityId={entityId}
                    />
                </div>
            </TimesheetHolidayGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    date: makeSelectTimesheetEntryValue('date'),
    entityId: makeSelectTimesheetEntryValue('entityId')
});

export default connect(mapStateToProps)(TimesheetEntryDateComponent);
